"use strict";

// import page related style
require("client/pages/bicsearch/style/index.css");
// import shared js functions
require("client/index.js");
require("client/swiftref_box.js");

let actor = {};
const actorFactory = require("client/pages/bicsearch/machine/actorFactory");
// const Machine = require("client/pages/bicsearch/machine.js");
const dataAccess = require("client/pages/bicsearch/data_access")();
const presentation = require("client/pages/bicsearch/presentation");
const staticData = require("client/static_data");
const elements = require("client/pages/bicsearch/elements");
// const http = require("../../http_client");


const machineConfig = {
    actions: {
        renderDialogErrors: function ({context}) {
            presentation.renderDialogErrors(context);
        },
        clearDialogErrors: function () {
            const container = elements.txt_file_dialog;
            presentation.clearErrors(container);
        },
        openDialog: function () {
            presentation.openTxtFileDialog();
        },
        closeDialog: function () {
            presentation.closeTxtFileDialog();
        },
        sendTxtEmail: function  ({context, event}) {

            dataAccess.sendTextEmail(event.payload).then(function (response) {
                const payload = {
                    message: {
                        type: "success",
                        text: response.data.message
                    }
                };
                actor.send({
                    type: "CLOSE",
                    payload: payload
                });
            }).catch(function (error) {
                const response = error.response;
                let event;
                if (!response) {
                    // no answer at all (network failure): still leave `sending`, or the
                    // dialog could never be submitted again
                    event = {
                        type: "ERROR",
                        payload: {
                            name: staticData.errors.UNABLE_TO_SEND_EMAIL.name,
                            message: staticData.errors.UNABLE_TO_SEND_EMAIL.message
                        }
                    };
                } else if (response.status === staticData.errors.NUMBER_OF_TXT_EMAIL_EXCEEDED.code
                    // the directory file is missing on the server: nothing to retry in the dialog
                    || (response.data && response.data.name === staticData.errors.FILE_NOT_FOUND.name)) {
                    event = {
                        type: "CLOSE",
                        payload: {
                            message: {
                                type: "warning",
                                text: response.data.message
                            }
                        }
                    };
                } else {
                    event = {
                        type: "ERROR",
                        // an empty body (e.g. a refusal with no JSON) carries no fields:
                        // renderDialogErrors then falls back to the page banner
                        payload: response.data || {}
                    };
                }

                actor.send(event);

            });
        },
        readyOnEntry: function ({context}) {
            // only the search limit keeps the search disabled: any other banner (an
            // expired download link, a sent email) must not
            if (!context.number_of_requests_exceeded) {
                presentation.enableSearch();
            }
        },
        idleOnEntry: function () {
            presentation.disableSearch();
        },
        renderMessage: function ({context}) {
            if (context.message) {
                presentation.renderBanner({
                    state: context.message.type,
                    text: context.message.text
                });
            }
        },
        searchingOnEntry: function ({context, event}) {
            const payload = {
                limit: context.limit,
                offset: context.offset,
                ...context.form
            };

            dataAccess.search(payload).then(function (response) {

                actor.send({type: "SUCCESS", payload: response.data});
            }).catch(function (error) {

                if (error.response) {
                    const response = error.response;
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx

                    if (response.data && response.data.name === staticData.errors.NUMBER_OF_REQUESTS_EXCEEDED.name) {
                        actor.send({type: "FINAL_ERROR", payload: response.data});
                    } else {
                        // an empty body carries nothing: onSearchingError reads `payload.name`
                        actor.send({type: "ERROR", payload: response.data || {}});
                    }

                } else {
                    // No response at all (network failure), or the request could not be
                    // set up: still leave `searching`, which handles no SEARCH, or the
                    // page could never search again
                    console.log(error.request || error.message);
                    actor.send({
                        type: "ERROR",
                        payload: {
                            name: staticData.errors.INVALID_PARAMS.name,
                            message: staticData.errors.INVALID_PARAMS.message
                        }
                    });
                }
            });
        },
        gettingCaptchaOnEntry: function (context, event, payload) {
            presentation.clearErrors();
            // dataAccess.getCaptcha();


            dataAccess.getCaptcha().then(function (response) {

                actor.send({
                    type: "SUCCESS",
                    payload: {captcha: response.data.captcha}
                });

            }).catch(function (error) {
                // same text as a failed search with no response: the user is asked
                // to try again, and the machine goes back to `ready`
                actor.send({
                    type: "ERROR",
                    payload: {
                        name: staticData.errors.INVALID_PARAMS.name,
                        message: staticData.errors.INVALID_PARAMS.message
                    }
                });
            });
        },
        // downloadFile: function (context, event, payload) {
        //     dataAccess.downloadFile(payload.href);
        // },
        clearError: function () {
            presentation.hideTable();
            presentation.clearErrors();
            // a new search answers for itself: no earlier banner outlives it
            presentation.clearBanner();
        },
        renderCaptcha: function ({context}) {
            if (context.captcha) {
                presentation.renderCaptcha(context.captcha);
            }
        },
        toggleRequirementOnField: function ({context}) {
            presentation.toggleRequirementOnField(context.form);
        }
    }
};

/**
 * Instantiate a new actor from the machine
 */
const initialContext = {
    number_of_requests_exceeded: staticData.number_of_requests_exceeded,
    number_of_txt_email_exceeded: staticData.number_of_txt_email_exceeded
};
actor = actorFactory(machineConfig.actions, initialContext);
presentation.bindEventListeners(actor);

// setTimeout(function () {
//     const {value} = actor.getSnapshot();
//     actor.send({
//         "type": "OPEN_TXT_FILE_DIALOG",
//         "payload": {
//             "previous_state": value
//         }
//     }, {});
// }, 1000);

actor.subscribe((state) => {

    const currentState = state.value;
    const context = state.context;

    switch (currentState) {
        case "checking_required_fields":
            if (Object.keys(context.form).length) {
                actor.send({type: "READY"});
            } else {
                actor.send({type: "NOT_READY"});
            }
            break;
        case "error":
        case "final_error":
            // render no records found
            if (context.data && Array.isArray(context.data)) {
                presentation.renderData(context);
            } else {
                presentation.renderErrors(context);
                presentation.clearData();
            }
            if (context.captcha) {
                presentation.renderCaptcha(context.captcha);
            }
            break;
        case "show_records":
            presentation.renderData({
                count: context.count,
                data: context.data,
                limit: context.limit,
                offset: context.offset
            });
            break;

        default:
            break;
    }
});


document.addEventListener("DOMContentLoaded", (event) => {
    actor.send({
        type: "CHECK_REQUIRED_FIELDS",
        payload: {
            form: presentation.getMandatoryFields()
        }
    });


    /**
     * Try to download the txt file if the token property in the query string.
     *
     * @author Simone Sacchi
     * @version 2026/03/17
     */
    if (window.location.search?.includes("token")) {
        const payload = {
            href: staticData.links.link_05 + window.location.search
        };
        document.dispatchEvent(
            new CustomEvent('DOWNLOAD_FILE', { "detail": payload })
        );
    }
});
